import { render, staticRenderFns } from "./PhotoListings.vue?vue&type=template&id=c2340dba"
import script from "./PhotoListings.vue?vue&type=script&lang=js"
export * from "./PhotoListings.vue?vue&type=script&lang=js"
import style0 from "./PhotoListings.vue?vue&type=style&index=0&id=c2340dba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports